import { HeaderContent } from '../components/shell/app-header';
import { authClient } from '../lib/auth-client';
import { useNavigate } from '../lib/routing';

export default function PendingAccount() {
  const navigate = useNavigate();
  const signOut = async () => {
    await authClient.signOut();
    navigate('/');
  };
  return (
    <>
      <HeaderContent width="md" showBurger>{null}</HeaderContent>
      <main className="flex flex-col items-center justify-center min-h-[60vh] px-5 text-center gap-6">
        <div className="text-[40px]" aria-hidden>🏫</div>
        <div className="max-w-[420px]">
          <h1 className="text-[20px] font-extrabold text-foreground mb-2">Il manque votre établissement</h1>
          <p className="text-[14px] text-muted-foreground leading-relaxed">
            Naïa est fourni par les établissements scolaires. Votre compte est bien créé : il attend
            d'être rattaché à une école pour s'ouvrir.
          </p>
          <p className="text-[13px] text-muted-foreground leading-relaxed mt-3">
            Si votre établissement utilise déjà Naïa, sa direction peut vous rattacher avec l'adresse
            que vous venez d'utiliser. Vos informations sont conservées : revenez quand vous voulez
            avec la même adresse.
          </p>
        </div>
        <button
          type="button"
          onClick={() => void signOut()}
          className="px-5 py-2 bg-transparent border-none text-[13px] font-semibold text-muted-foreground underline hover:text-foreground transition-colors min-h-[44px] cursor-pointer font-[inherit]"
        >
          Se déconnecter
        </button>
      </main>
    </>
  );
}
